// @flow

import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// constants
import Constants from 'constants/Constants';

// entities
import AvailabilityHours from 'PMT/entities/menu/AvailabilityHours';
import AvailabilityHoursForDay from 'PMT/entities/menu/AvailabilityHoursForDay';
import AvailabilityHour from 'PMT/entities/menu/AvailabilityHour';

// views
import AvailabilityHoursForDayView from './AvailabilityHoursForDayView';
import AddAvailabilityHourModal from './AddAvailabilityHourModal';

export default class AvailabilityHoursForm extends Component {

  static defaultProps = {
    availabilityHours: new AvailabilityHours(),

    readOnly: false,
  };

  static propTypes = {
    availabilityHours: PropTypes.objectOf(AvailabilityHours),

    onAvailibilityHoursChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool,
  };

  state = {
    displayAddAvailabilityHourModal: false,

    addAvailabilityHourModalDefaultDay: Constants.Day.MONDAY
  };

  //
  //
  //

  onChangeForDay = (day: DayIndex, availabilityHoursForDay: AvailabilityHoursForDay) => {
    const availabilityHours: AvailabilityHours = this.props.availabilityHours.copy()
    availabilityHours.setForDay(day, availabilityHoursForDay);
    this.props.onAvailibilityHoursChange(availabilityHours);
  };

  addAvailabilityHourForDay = (day: DayIndex, availabilityHour: AvailabilityHour) => {
    const availabilityHours: AvailabilityHours = this.props.availabilityHours.copy()
    availabilityHours.addForDay(day, availabilityHour);
    this.props.onAvailibilityHoursChange(availabilityHours);
  };

  //
  //
  //

  // -- events modal
  displayAddAvailabilityHourModal = (defaultDay: number = Constants.Day.MONDAY) => {
    this.setState({
      displayAddAvailabilityHourModal: true,
      addAvailabilityHourModalDefaultDay: defaultDay
    });
  };

  hideAddAvailabilityHourModal = () => {
    this.setState({
      displayAddAvailabilityHourModal: false
    });
  };

  //
  //
  //


  renderBody() {
    const availabilityHours: AvailabilityHours = this.props.availabilityHours;

    const days = [
      Constants.Day.MONDAY,
      Constants.Day.TUESDAY,
      Constants.Day.WEDNESDAY,
      Constants.Day.THURSDAY,
      Constants.Day.FRIDAY,
      Constants.Day.SATURDAY,
      Constants.Day.SUNDAY,
    ];

    const suggestedHour = availabilityHours.getSuggestAvailabilityHour()

    return (
      <div>
        <div
          className="availability_hours_form__week"
          style={{
            // overflowX: 'auto',
            // whiteSpace: 'nowrap',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          {days.map((day, index) => {
            return (
              <div
                key={day}
                className="availability_hours_form__day"
              >
                <AvailabilityHoursForDayView
                  key={day}
                  day={day}
                  availabilityHoursForDay={availabilityHours.getForDay(day)}
                  suggestedHour={suggestedHour}
                  onChangeForDay={this.onChangeForDay}
                  readOnly={this.props.readOnly}
                  onAddAvailabilityClick={this.displayAddAvailabilityHourModal}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderAddAvailabilityHourModal() {
    if (!this.state.displayAddAvailabilityHourModal) {
      return (null);
    }

    const defaultDay = this.state.addAvailabilityHourModalDefaultDay;

    // Get a default opening hour suggestion based on all the others opening hours
    const defaultAvailabilityHour: AvailabilityHour = this.props.availabilityHours.getSuggestAvailabilityHourForDay(defaultDay);

    return (
      <AddAvailabilityHourModal
        show={this.state.displayAddAvailabilityHourModal}
        onHide={this.hideAddAvailabilityHourModal}
        onAddAvailabilityHourForDay={this.addAvailabilityHourForDay}
        defaultAvailabilityHour={defaultAvailabilityHour}
        defaultDay={defaultDay}
      />
    );
  }

  render() {
    try {
    return (
      <div className="col-xs-12 availability_hours_form">
        <div>
          {this.renderBody()}
          {this.renderAddAvailabilityHourModal()}
        </div>
      </div>
    );
  } catch (e) { console.error(e); }
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForm.js